/* eslint max-len: 0, react/no-danger: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DataList from 'components/ui/DataList';
import SessionStore from 'stores/SessionStore';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
const appointmentWindowFields = ['pickup', 'deliver'];
class ShipmentList extends Component {
    constructor() {
        super(...arguments);
        this.getColumnMappings = () => {
            return this.props.columns.map((col) => {
                const { t } = this.props;
                if (col.dataField === 'shipment_id' && SessionStore.isAdmin()) {
                    return Object.assign(Object.assign({}, col), { formatExtraData: Object.assign(Object.assign({}, (col.formatExtraData || {})), { onClick: this.props.onShipmentIdClick }) });
                }
                if (col.type === 'daterange') {
                    return Object.assign(Object.assign({}, col), { formatExtraData: Object.assign({}, (col.formatExtraData || {})) });
                }
                if (SessionStore.isCarrier() &&
                    appointmentWindowFields.includes(col.dataField)) {
                    return Object.assign(Object.assign({}, col), { formatExtraData: Object.assign(Object.assign({}, col.formatExtraData), { onWindowEdit: this.props.onWindowEdit, isCarrier: true }) });
                }
                return Object.assign(Object.assign({}, col), { headerText: titleize(t(col.localizationSlug)) });
            });
        };
        this.shouldRowHighlight = (row) => {
            if (!row)
                return;
            if (!SessionStore.isAdmin())
                return;
            const { shipper } = row;
            const status = shipper && shipper.status ? shipper.status : '';
            const classNames = classnames({
                'bg-blue-lighter': ['Service Watch', 'New Customer'].indexOf(status) > -1,
                'bg-yellow-200': row.on_hold,
            });
            return classNames;
        };
    }
    render() {
        const { t } = this.props;
        if (this.props.shipments.length === 0 && this.props.done) {
            return React.createElement("div", null, t('NO_MATCHING_SHIPMENT_FOUND'));
        }
        if (this.props.shipments.length === 0) {
            return React.createElement("div", null, t('SEARCHING_FOR_SHIPMENTS'));
        }
        return (React.createElement("div", { className: "overflow-x-auto" },
            React.createElement(DataList, { select: true, showHeaders: true, paginate: true, data: this.props.shipments, columns: this.getColumnMappings(), hiddenColumns: this.props.hiddenColumns, total: this.props.totalEntries, pages: this.props.pages, page: this.props.page, perPage: this.props.per_page, onPaginationSelect: (page) => this.props.onPaginationSelect(page), selected: this.props.selected, onSelect: (row, selected) => {
                    this.props.onHandleSelection(row, selected);
                }, onSelectAll: (selected) => this.props.onHandleSelectAll(selected), shouldRowHighlight: this.shouldRowHighlight })));
    }
}
ShipmentList.propTypes = {
    columns: PropTypes.array,
    hiddenColumns: PropTypes.array,
    shipments: PropTypes.array,
    onShipmentIdClick: PropTypes.func.isRequired,
    onWindowEdit: PropTypes.func.isRequired,
    page: PropTypes.number,
    pages: PropTypes.number,
    selected: PropTypes.array,
    done: PropTypes.bool.isRequired,
    onPaginationSelect: PropTypes.func.isRequired,
    onHandleSelectAll: PropTypes.func.isRequired,
    onHandleSelection: PropTypes.func.isRequired,
};
export default withTranslation()(ShipmentList);
